import React from 'react';
import { Container } from 'react-bootstrap';

const PrivacyPolicyPage = () => {
  return (
    <Container className="py-5">
      <div className="mx-auto" style={{ maxWidth: '900px' }}>
        <h1 className="text-center mb-4">Privacy Policy</h1>

        <p>
          © 2019 Stash House Distribution. No portion of this website — inclusive of, but not limited to,
          photographs, illustrations, copy and look &amp; feel — may be used or reproduced by any means
          without the express written consent of Stash House Distribution. All trademarks herein are the
          property of their respective owners who have all the rights therein. No trademarks or service
          marks may be used or reproduced without the express written consent of their respective owners.
        </p>

        <h2 className="text-center mt-5 mb-3">Privacy Statement</h2>
        <p>
          We respect your privacy. The information you provide us is used to stay in communication with
          you via email, phone, and USPS mail. We may provide you with special offers, announcements and
          invitations when you provide us with your information. Your information will not be sold or shared.
        </p>

        <h2 className="text-center mt-5 mb-3">What data we collect</h2>
        <p>Stash House may collect the following information about you:</p>
        <ul>
          <li>Your name</li>
          <li>Your contact details (email address, telephone numbers).</li>
          <li>Your correspondence with Stash House.</li>
          <li>Your communication and marketing preferences.</li>
          <li>Your interests, preferences, feedback, and survey responses.</li>
          <li>Your online browsing activities on mmjdist.azurewebsites.net.</li>
          <li>Your location.</li>
          <li>Other publicly available information you have shared via a public platform.</li>
        </ul>
        <p>
          In certain instances, such as applications for residency, we may need to collect more detailed
          personal information. Some of your personal data is collected in a direct manner; for example,
          when you provide your name and contact details to submit an inquiry with Stash House Distribution.
          Other personal data may be collected indirectly; for example, your browsing history as you interact
          with our website. We may also receive personal data from trusted third parties who provide services
          to Stash House.
        </p>

        <h2 className="text-center mt-5 mb-3">Use of Cookies</h2>
        <p>
          A cookie is a small text file containing information that a web site transfers to your computing
          device for record-keeping purposes. A cookie cannot give us access to any information beyond what
          you provide us. Cookies store information about browsing behavior and consumer preferences and can
          be used to analyze the user experience and personal journey around our website. Most web browsers
          automatically accept and save cookies; consult your browser's help documentation if you want
          information about altering your browser's settings regarding cookie processing. If you disable
          cookies you may still view the publicly available information on our website.
        </p>

        <h2 className="text-center mt-5 mb-3">Google Analytics</h2>
        <p>
          Stash House Distribution uses a third-party service, Google Analytics, to collect standard internet
          log information and details of behavior patterns for visitors of our website. Stash House Distribution
          does not make any attempt to correlate that usage data with a personal identity. We use this service
          to find out how our visitors are interacting with our website, what changes we can make to improve
          the browsing experience, and to evaluate the results of our marketing efforts.
        </p>

        <h2 className="text-center mt-5 mb-3">Our partners</h2>
        <p>
          In the exercise of providing certain services to you, we may have a need to share some of your
          personal data with one of our trusted partners.
        </p>
        <p>
          Stash House Distribution will only transmit your personal data to partners who share our commitment
          to data protection and privacy.
        </p>
        <p>
          Aside from our trusted service providers, Stash House Distribution will not disclose or sell your
          personal data to any third party, unless required by law.
        </p>

        <h2 className="text-center mt-5 mb-3">Legal basis for processing data</h2>
        <p>
          Stash House Distribution collects and processes customers' personal data because it is required
          for the pursuit of legitimate business interests:
        </p>
        <ul>
          <li>Selling and supplying products and services to our customers.</li>
          <li>Fulfilling duties to our customers, employees, shareholders and other stakeholders.</li>
          <li>Promoting, marketing, and advertising our products and services.</li>
          <li>Sending promotional communications relevant to specific customers.</li>
          <li>Understanding our customer's needs, activities, preferences, and behavior.</li>
          <li>Offering improvements to our existing products and services and developing new products and services.</li>
          <li>Complying with legal and regulatory obligations.</li>
          <li>Being effective in defense of legal claims or regulatory enforcement actions.</li>
          <li>Preventing, detecting, and investigating crime or fraud, including working with law enforcement agencies.</li>
          <li>Protecting Stash House, its customers and employees, by taking legal action against criminal acts of third parties.</li>
        </ul>

        <h2 className="text-center mt-5 mb-3">Your rights</h2>
        <p>You have the following rights:</p>
        <ul>
          <li>The right of access. The right to ask for a copy of your personal data that we retain.</li>
          <li>The right to erasure. The right, in certain circumstances, to ask us to delete your personal data, should we no longer have a legal reason to hold it.</li>
          <li>The right of rectification. The right to ask for your personal data be updated or corrected.</li>
          <li>The right to object. The right to opt out of marketing communication or object to the use of your data should we not have a legitimate reason to do so.</li>
          <li>The right to restrict processing. The right, in certain circumstances, to ask us to retain and secure your personal data but not otherwise use it.</li>
          <li>The right of data portability. The right, in certain circumstances, to ask us to prepare and transmit some of your personal data to another organization in a structured format.</li>
        </ul>
        <p>
          If you wish to exercise any of the rights listed above, please email{' '}
          <a href="mailto:shdwebsite@stashhousedistro.com">shdwebsite@stashhousedistro.com</a> with the details
          of your request.
        </p>

        <h2 className="text-center mt-5 mb-3">Updates</h2>
        <p>
          This policy was last updated in November 25th, 2019. We reserve the right to change our privacy
          policy at any time. The latest version of our policy can always be found on this web page.
        </p>

        <h2 className="text-center mt-5 mb-3">
          <a target="_blank" rel="noopener noreferrer" href="https://www.stashhousedistro.com">stashhousedistro.com</a> Privacy Shield Policy
        </h2>
        <p>
          <a target="_blank" rel="noopener noreferrer" href="https://www.stashhousedistro.com">stashhousedistro.com</a> hosts,
          maintains and or developed this website.
        </p>
        <p>
          <a target="_blank" rel="noopener noreferrer" href="https://www.stashhousedistro.com">stashhousedistro.com</a> complies
          with the EU-U.S. Privacy Shield Framework as set forth by the U.S. Department of Commerce regarding the collection,
          use, and retention of personal information transferred from the European Union and the United Kingdom to the United
          States in reliance on Privacy Shield.{' '}
          <a target="_blank" rel="noopener noreferrer" href="https://www.stashhousedistro.com">stashhousedistro.com</a> has
          certified to the Department of Commerce that it adheres to the Privacy Shield Principles with respect to such
          information. If there is any conflict between the terms in this privacy policy and the Privacy Shield Principles,
          the Privacy Shield Principles shall govern. To learn more about the Privacy Shield program, and to view our
          certification, please visit{' '}
          <a href="https://www.privacyshield.gov/" target="_blank" rel="noopener noreferrer">https://www.privacyshield.gov/</a>.
        </p>
        <p>
          In compliance with the Privacy Shield Principles,{' '}
          <a target="_blank" rel="noopener noreferrer" href="https://www.stashhousedistro.com">stashhousedistro.com</a> commits
          to resolve complaints about our collection or use of your personal information. EU individuals with inquiries or
          complaints regarding our Privacy Shield policy should first contact{' '}
          <a target="_blank" rel="noopener noreferrer" href="https://www.stashhousedistro.com">stashhousedistro.com</a> at:{' '}
          <a href="mailto:shdwebsite@stashhousedistro.com">shdwebsite@stashhousedistro.com</a>
        </p>
        <p>
          An individual may under certain conditions invoke binding arbitration. Please see the Privacy Shield website for
          more information on conditions giving rise to binding arbitration.
        </p>
        <p>
          <a target="_blank" rel="noopener noreferrer" href="https://www.stashhousedistro.com">stashhousedistro.com</a> commits
          to cooperate with EU and UK data protection authorities (DPAs) and comply with the advice given by such authorities
          with regard to data transferred from the EU and UK.
        </p>
        <p>
          <a target="_blank" rel="noopener noreferrer" href="https://www.stashhousedistro.com">stashhousedistro.com</a> is
          responsible for the third party acts within its control that result in the processing of personal data inconsistent
          with the Privacy Shield Program.
        </p>
        <p>
          <a target="_blank" rel="noopener noreferrer" href="https://www.stashhousedistro.com">stashhousedistro.com</a> is
          also subject to the authority of the Federal Trade Commission.
        </p>

        <h2 className="text-center mt-5 mb-3">Questions and feedback</h2>
        <p>
          We welcome your questions, comments, and concerns about privacy. Please send us any and all feedback pertaining
          to privacy, or any other issue. If you want to send feedback to us about a privacy issue or anything else,{' '}
          <a href="mailto:shdwebsite@stashhousedistro.com">CLICK HERE.</a>
        </p>

        <h2 className="text-center mt-5 mb-3">Online Policy</h2>
        <p>
          This online privacy policy applies only to information collected through our website and not to information
          collected offline.
        </p>

        <p className="text-center mt-5 fw-bold">
          By using our site, you consent to our privacy policy.
        </p>
      </div>
    </Container>
  );
};

export default PrivacyPolicyPage;